export enum ApiEndpoint {
  STANDARD,
}

export const endpointDict = {
  [ApiEndpoint.STANDARD]: process.env.VUE_APP_API_ENDPOINT,
};
